import React from 'react';
import OrdersList from '../component-list-orders';
import Suspense from '../../Common/components/Suspense-component';
import { getCompaniesList, getPharmaciesForSingleCompany } from '../../Companies/epics-companies';
import localStorage from '../../Common/LocalStorage';
import { UserRole } from '../../Common/UserRole';
import { getCompanyOfUser, getPharmacyOfUser, getUserStatus } from '../../Users/epics-users';

export class OrdersContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            orderBy: 'names',
            orderDirection: 'asc',
            page: 0,
            limit: 30
        };
    }

    generateCompanyList = () => {
        switch (localStorage.getUsernameRole()) {
            case UserRole.ADMIN:
                return getCompaniesList();
            case UserRole.STORE_OWNER:
                return getCompanyOfUser();
            case UserRole.PHARMACY_MANAGER:
                return getCompanyOfUser();
            default:
                return [];
        }
    };

    generatePharmacyList = id => {
        switch (localStorage.getUsernameRole()) {
            case UserRole.ADMIN:
                return typeof id !== 'undefined' ? getPharmaciesForSingleCompany(id) : null;
            case UserRole.STORE_OWNER:
                return id ? getPharmaciesForSingleCompany(id) : [];
            case UserRole.PHARMACY_MANAGER:
                return getPharmacyOfUser();
            default:
                return [];
        }
    };

    render() {
        return (
            <Suspense
                apiCalls={{
                    status: () => getUserStatus(),
                    companyList: () => this.generateCompanyList(),
                    pharmacyList: id => this.generatePharmacyList(id)
                }}
            >
                <OrdersList />
            </Suspense>
        );
    }
}



// WEBPACK FOOTER //
// ./src/customModules/Orders/containers/container-list-orders.js